const checkIsNotEmptyParams = (object): boolean => {
  return Object.keys(object).some((key) => Boolean(object[key]))
}

export default checkIsNotEmptyParams
